/**
 * @desc 保存权限配置
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.PermissionConfigureRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/role/permission/configure`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
